import React from 'react'
import PropTypes from 'prop-types'
import { Box, themeColor } from '@elparking/components'
import styled from 'styled-components'
import Routes from 'commons/js/routes/routes'
import CashbackBlock from './Cashback'
import OfferApplied from './OfferApplied'
import PriceDetails from './PriceDetails'
const Container = styled(Box)`
    border: 1px solid ${themeColor('lightGray40')};
`
const ExtraInfoBlock = ({
    booking,
    cashbackInfoURL,
}) => {
    return (
        <Container mt='1em' padding='1em'>
            <PriceDetails booking={booking} />
            <OfferApplied />
            {!booking.createdByOperator && <CashbackBlock cashbackInfoURL={cashbackInfoURL} />}
        </Container>
    )
}

ExtraInfoBlock.propTypes = {
    booking: PropTypes.object,
    cashbackInfoURL: PropTypes.string,
}

ExtraInfoBlock.defaultProps = {
    booking: {},
    cashbackInfoURL: Routes.cashbackInfoURL(),
}
export default ExtraInfoBlock
